import { render, staticRenderFns } from "./baiduMap.vue?vue&type=template&id=37057271&scoped=true&"
import script from "./baiduMap.vue?vue&type=script&lang=js&"
export * from "./baiduMap.vue?vue&type=script&lang=js&"
import style0 from "./baiduMap.vue?vue&type=style&index=0&id=37057271&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37057271",
  null
  
)

export default component.exports